module.exports = __webpack_public_path__ + "img/hyundai-logo.869ce703.jpg";